module.exports = "/images/pin-photography-active.png?d45bd24d78d7bdcb5161c12e72cd1f75";